
import {fetchExchangeRate, updateExchangeRate} from "../actions/"
const stateToProps = (state) => {
    return {
        curentExchangeRate:state.exchangeRate.curentExchangeRate,
        accessToken: state.login.employeeInfo.accessToken,

    }
};
const mapDispatchToProps = (dispatch) => {
    return {
        getCurrentExchangeRate: (currency) => {
        dispatch(fetchExchangeRate({currency}));
        },
       updateRecoredExchageRate: (costData,token,cb) => {
            dispatch(updateExchangeRate({
              costData: costData,
              accessToken: token,
              status: true,
              sendToConfirmation: 0,
              cb: cb,
            }));
          }
    };
};


export default [stateToProps, mapDispatchToProps];
